import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Reason, ReasonScope } from "@models/reason.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-reasons-table',
    templateUrl: './reasons-table.component.html',
    styleUrls: ['./reasons-table.component.scss']
})
export class ReasonsTableComponent implements OnInit {

    @Input() reasons = new Array<Reason>();
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    scopeFilters = [];

    constructor(private translateService: TranslateService) {
    }

    ngOnInit() {
        this.buildScopeFilters();
    }

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this.rowClick.emit(clickedItem);
    }

    getScopeTranslationKey(scope: ReasonScope) {
        switch (scope) {
            case ReasonScope.TicketOnHold:
                return 'admin.reasons.modal.scope.options.ticketOnHold';
            case ReasonScope.ToolIssue:
            default:
                return 'admin.reasons.modal.scope.options.toolIssue';
        }
    }

    private buildScopeFilters() {
        this.translateService.get([
            'generic.statuses.all',
            'admin.reasons.modal.scope.options.toolIssue',
            'admin.reasons.modal.scope.options.ticketOnHold'
        ]).subscribe(translations => {
            this.scopeFilters = [
                {
                    name: translations['generic.statuses.all'],
                    value: ''
                },
                {
                    name: translations['admin.reasons.modal.scope.options.toolIssue'],
                    value: ReasonScope.ToolIssue
                },
                {
                    name: translations['admin.reasons.modal.scope.options.ticketOnHold'],
                    value: ReasonScope.TicketOnHold
                }
            ];
        });
    }
}
